import { Col, ConfigProvider, Drawer, Image, Row } from 'antd';

import clsx from 'clsx';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import logo from '../../../../assets/logo.svg';
import {
  closeDrawerMenu,
  selectOpenDrawerMenu,
  selectOpenSubMenu,
  toggleDrawerMenu,
} from '../../../../modules/ui/store/ui-slice';
import HamburgerButton from '../../../../shared/components/hamburger-button/hamburger-button';
import { useBreakpoint } from '../../../../shared/hooks/use-breakpoint';
import { useAppSelector } from '../../../../store/hooks';
import useMenuItems from '../../hooks/use-menu-items';
import MainMenuMobile from '../main-menu-mobile/main-menu-mobile';
import MainMenuTablet from '../main-menu-tablet/main-menu-tablet';
import styles from './side-drawer.module.css';

interface Props {
  submenuContent: ReactNode;
}

const SideDrawer = ({ submenuContent }: Props): JSX.Element => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const screens = useBreakpoint();
  const [_, activeMenuItem] = useMenuItems();
  const drawerMenu = useAppSelector(selectOpenDrawerMenu);
  const openSubMenu = useAppSelector(selectOpenSubMenu);

  const getSideDrawerSize = () => {
    if (screens.xs) {
      return 'default';
    }
    return openSubMenu && activeMenuItem?.subMenuContent ? 471 : 209;
  };
  return (
    <ConfigProvider
      theme={{
        token: {
          paddingLG: 0,
        },
      }}
    >
      <Drawer
        closable={false}
        size={getSideDrawerSize()}
        placement="left"
        open={drawerMenu}
        onClose={() => dispatch(closeDrawerMenu())}
        styles={screens.xs ? { wrapper: { width: '100%' } } : undefined}
      >
        <div className={clsx(screens.xs ? styles.mobileContainer : styles.tabletContainer)}>
          <Row className={styles.drawerHeader} align="middle">
            <Col span={8}>
              <HamburgerButton
                changeIcon={true}
                isOpened={drawerMenu}
                isDisabled={false}
                extraMargin={false}
                buttonProps={{
                  onClick: () => dispatch(toggleDrawerMenu()),
                }}
              />
            </Col>
            {screens.xs && (
              <Col span={8} flex="auto">
                <Row justify="center">
                  <Col>
                    <Image src={logo} alt={t('header.logo')} preview={false} />
                  </Col>
                </Row>
              </Col>
            )}
            <Col span={8} />
          </Row>
          <div className={clsx({ [styles.tabletContent]: screens.sm })}>
            <div className={styles.drawerMainMenu}>{screens.xs ? <MainMenuMobile /> : <MainMenuTablet />}</div>
            {openSubMenu && !screens.xs && <div>{submenuContent}</div>}
          </div>
        </div>
      </Drawer>
    </ConfigProvider>
  );
};

export default SideDrawer;
